import { getLocale } from "../runtime";

const sv_products = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Produkter`
};

const products = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_products(inputs)
	return "products";
};

export { products as "products" };